import React from 'react';
import {Skeleton} from '@material-ui/lab';
import {Typography, TypographyProps} from '@material-ui/core';

export type HeaderSkeletonProps = TypographyProps & {height?: number; width?: number};

const HeaderSkeleton: React.FC<HeaderSkeletonProps> = ({
    variant = 'h2',
    height = 100,
    width,
    ...rest
}) => (
    <Typography variant={variant} {...rest}>
        <Skeleton height={height} width={width} />
    </Typography>
);

export default HeaderSkeleton;
